package nl.volleyplanner.api.sports

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlinx.serialization.builtins.MapSerializer
import kotlinx.serialization.serializer
import nl.volleyplanner.sportconfig.NevoboTeamName
import nl.volleyplanner.types.AgeGroup
import nl.volleyplanner.util.ObjectToStringSerializer

@Serializable
data class Club(
    val clubId: String,
    val name: String
)

@Serializable
data class BasicTeam(
    val teamId: String,
    val name: String,
    val number: Int,
    val ageGroup: AgeGroup
)

@Serializable
enum class CompetitionType {
    Season,
    CupTournament,
    Championships,
    SittingVolleyball,
    Recreative
}

@Serializable
data class BasicPoule(
    val pouleId: String,
    val name: String,
    val pouleCode: String,
    val competitionType: CompetitionType
)

@Serializable
data class FullPoule(
    val name: String,
    val pouleId: String,
    val pouleCode: String,
    val competitionType: CompetitionType,
    val scoringMethod: ScoringMethod?,
    val lastFullSync: LocalDateTime
)

object PossibleResultsSerializer : KSerializer<Map<Pair<Double, Double>, Pair<Int, Int>>> by MapSerializer(
    keySerializer = ObjectToStringSerializer<Pair<Double, Double>>(
        "IntPair",
        { pair -> "${pair.first}-${pair.second}" },
        { s -> s.split("-").let { Pair(it[0].toDouble(), it[1].toDouble()) } }),
    valueSerializer = serializer<Pair<Int, Int>>()
)

@Serializable
data class ScoringMethod(
    val name: String,
    @Serializable(with = PossibleResultsSerializer::class)
    val possibleResults: Map<Pair<Double, Double>, Pair<Int, Int>>,
    val minimumPointsRegularSet: Int,
    val minimumPointsDecisiveSet: Int,
    val minimumDifferenceRegularSet: Int,
    val minimumDifferenceDecisiveSet: Int,
) {
    fun isValidScore(setsA: Double, setsB: Double): Boolean {
        return possibleResults.containsKey(Pair(setsA, setsB))
    }

    fun calculatePoints(setsA: Double, setsB: Double): Pair<Int, Int> {
        return possibleResults.getOrElse(Pair(setsA, setsB), {
            throw IllegalArgumentException("Invalid sets combination: $setsA, $setsB")
        })
    }
}